var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgMink = function SvgMink(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9579_11558)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_9579_11558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.7825 7.29343C16.5287 7.16343 16.2439 7.09533 15.9591 7.09533C15.2844 7.09533 14.6653 7.47914 14.362 8.08581L13.0806 9.70152C12.8329 10.011 12.4615 10.1906 12.0653 10.1906C11.7187 10.1906 11.3906 10.0606 11.1491 9.80676C10.6229 9.25581 9.96057 8.30866 7.42866 8.33343C4.62438 8.352 3.93724 10.6425 3.77009 11.6144C2.97152 11.0015 2.47628 10.172 2.47628 9.262C2.47628 7.51628 3.26247 6.30914 6.37009 6.17914C6.78485 6.16057 7.11914 5.82009 7.11914 5.39914C7.11914 4.97819 6.77247 4.61914 6.33914 4.61914H5.262C2.69914 4.61914 0.619141 6.42057 0.619141 8.64295C0.619141 10.432 1.96866 11.9487 3.83819 12.4687L4.95247 16.381H7.42866L6.19057 15.4525L6.57438 13.6015C6.71057 13.0506 7.20581 12.6668 7.77533 12.6668H10.2515C10.7839 12.6668 11.2606 13.0072 11.4277 13.5149L12.381 16.381H14.2382L13.0001 15.4525V13.9049C14.3929 13.1125 15.4206 11.8125 15.8849 10.2772L16.0953 9.57152C17.8287 9.59628 19.1906 8.33343 19.1906 8.33343C18.8625 8.35819 17.4696 7.65247 16.7825 7.29343Z",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9579_11558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_9579_11558"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 19.8095,
    height: 13,
    fill: "white",
    transform: "translate(0 4)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgMink);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "mink.b7c556d5f85fea2132524419134cd36e.svg";